<div class="p-3">
    <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event)">
        <div class="example-box p-3 border-bottom-1 surface-border hover:surface-100 transition-colors cursor-move" 
             *ngFor="let analite of analites, let i=index" cdkDrag>
            <i class="pi pi-bars mr-2 text-400"></i>
            <span class="font-medium">{{analite.index}} - {{analite.analite}}</span>
        </div>
    </div>

    <div class="flex justify-content-start gap-2 mt-4">
        <p-button label="Guardar" 
                  [disabled]="disbledSaveButton()" 
                  (onClick)="_reorderAnalites(analites)"
                  severity="primary"></p-button>

        <p-button label="Cancelar" 
                  (onClick)="closeDialog()" 
                  severity="danger" 
                  [text]="true"></p-button>

        <div *ngIf='isSaving' class="flex align-items-center gap-3">
            <p-progressSpinner styleClass="w-2rem h-2rem"></p-progressSpinner> 
            <span class="text-sm font-medium">{{spinnerMessage}}</span>
        </div>
    </div>
</div>
